<!-- <div
  class="min-h-screen bg-[url('https://shotkit.com/wp-content/uploads/2020/11/landscapephotography001-1.jpg')] bg-cover bg-center bg-no-repeat flex items-center justify-center">
  <div class="bg-white/10 backdrop-blur-sm rounded-lg p-8 max-w-md w-full mx-4">
    <form class="space-y-6">
      <div class="text-center">
        <h2 class="text-3xl font-bold text-white mb-2">Welcome Back</h2>
        <p class="text-gray-200">Please sign in to continue</p>
      </div>

      <div class="space-y-4">
        <ig-field [control]="form.get('userName')" label="Account Name" icon="link"></ig-field>

        <ig-field [control]="form.get('password')" label="Password" icon="link"></ig-field>
      </div>

      <ig-button type="submit" cls="w-full bg-blue-500 hover:bg-blue-600 text-white" [isAsync]="true"
        (trigger)="login($event)">
        Sign In
      </ig-button>
    </form>
  </div>
</div> -->

<div
  class="ig-login-bg flex justify-center items-center h-screen bg-[url('https://iti-images.s3.us-east-1.amazonaws.com/imgs/login-bg1.jpeg')] bg-cover bg-center bg-no-repeat">
  <!-- class="ig-login-bg flex justify-center items-center h-screen bg-[url('https://shotkit.com/wp-content/uploads/2020/11/landscapephotography001-1.jpg')] bg-cover bg-center bg-no-repeat"> -->
  <div class="min-h-screen text-gray-700 w-[900px] flex items-center justify-center">
    <div class="bg-white bg-opacity-60 backdrop-blur-lg shadow-lg p-8 rounded-2xl w-[450px]">
      <div class="flex justify-center items-center mb-6">
        <img class="w-1/2" alt="logo" src="https://dev.imgoingcalendar.com/assets/imgs/logo3.png" width="100">
      </div>

      <h3 class="text-gray-600">DIGITAL EXPERIENCE PLATFORM (DXP)</h3>
      <p class="text-gray-600 !mt-2 !mb-6 text-center text-sm">
        Manage website content with ease. Publish events, business listings and create itineraries using the power of
        dynamic
        content.
      </p>

      <!-- <button class="flex items-center justify-center w-full bg-gray-200 text-gray-700 py-2 rounded-lg mb-4">
      <img src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg" alt="Facebook"
        class="w-5 h-5 mr-2">
      Facebook
    </button> -->

      <form class="login-form" ngForm="loginFormGroup" method="post">
        <div class="my-4">
          <label class="block text-gray-600 text-sm mb-1">Account Name</label>
          <div class="flex items-center bg-white border border-gray-300 rounded-lg py-2 px-3">
            <span class="text-gray-400 mr-2">👤</span>
            <input id="username" type="text" [(ngModel)]="credentials.userName" name="username" autocomplete="username"
              class="w-full h-8 focus:outline-none" placeholder="Account Name" (keydown.enter)="login()">
          </div>
        </div>

        <div class="mb-6">
          <label class="block text-gray-600 text-sm mb-1">Password</label>
          <div class="flex items-center bg-white border border-gray-300 rounded-lg py-2 px-3">
            <span class="text-gray-400 mr-2">🔑</span>
            <input id="password" type="password" [(ngModel)]="credentials.password" name="password"
              autocomplete="current-password" class="w-full h-8 focus:outline-none" placeholder="Password"
              (keydown.enter)="login()">
            <!-- <a href="#" class="text-gray-500 text-sm">I forgot</a> -->
          </div>
        </div>

        <ig-button #loginBtn class="flex items-center justify-center w-full text-white overflow-hidden p-1"
          cls="w-full !h-12 !rounded-[24px] flex justify-center" [isAsync]="true" (trigger)="login($event)">
          LOGIN
        </ig-button>
        <div class="flex items-center justify-center mt-1 text-sm text-red-500">{{accountStatus}}</div>

        <a class="flex items-center justify-center w-full mt-4 text-xs text-gray-600" target="_blank"
          href="https://itidigital.freshdesk.com/support/tickets/new">
          Forgot password?<span class="underline ml-2">Contact our team</span>
        </a>
      </form>

    </div>

    <!-- <div class="w-[350px] text-gray-200">
      <h1>DIGITAL</h1>
      <h1>EXPERIENCE</h1>
      <h1>PLATFORM</h1>
      <h1>(DXP)</h1>
      <p class="text-gray-200 !mt-6 !mb-6 text-center text-base">
        Manage website content with ease. Publish events, business listings and create itineraries using the power of
        dynamic
        content.
      </p>
    </div> -->
  </div>


</div>